<ion-card class="app-background ion-padding">
  <form [formGroup]="contactDetailsForm" (ngSubmit)="submitNewUser()">
    <ion-grid class="ion-padding">
      <ion-row class="ion-text-center">
        <ion-col size="12">
          <ion-label class="panel-header-text" color="dark">
            {{ 'register_step1Title' | translate }}
          </ion-label>
        </ion-col>
      </ion-row>

      <ion-row class="ion-margin-top ion-align-items-start">
        <ion-col size="6" class="ion-padding-end">
          <ion-label class="panel-label-text"
            >{{ 'register_firstname' | translate }}*</ion-label
          >
          <ion-input
            fill="outline"
            type="text"
            formControlName="firstname"
            class="ion-margin-top"
            [class.is-invalid]="
              formHelper.isFieldValidCss('firstname', isFormSubmitAttempted())
            "
          >
          </ion-input>
        </ion-col>
        <ion-col size="6" class="ion-padding-start">
          <ion-label class="panel-label-text"
            >{{ 'register_lastname' | translate }}*</ion-label
          >
          <ion-input
            fill="outline"
            type="text"
            formControlName="lastname"
            class="ion-margin-top"
            [class.is-invalid]="
              formHelper.isFieldValidCss('lastname', isFormSubmitAttempted())
            "
          >
          </ion-input>
        </ion-col>
      </ion-row>

      <ion-row class="ion-padding-top">
        <ion-col size="12">
          <ion-label class="panel-label-text"
            >{{ 'register_phoneOrMobile' | translate }}*</ion-label
          >
          <ion-input
            fill="outline"
            type="tel"
            formControlName="telephone"
            class="ion-margin-top"
            [class.is-invalid]="
              formHelper.isFieldValidCss('telephone', isFormSubmitAttempted())
            "
          >
          </ion-input>
        </ion-col>
      </ion-row>

      <ion-row class="ion-padding-top">
        <ion-col size="12">
          <ion-label class="panel-label-text"
            >{{ 'register_email' | translate }}*</ion-label
          >
          <ion-input
            fill="outline"
            type="email"
            formControlName="email"
            class="ion-margin-top"
            [class.is-invalid]="
              formHelper.isFieldValidCss('email', isFormSubmitAttempted())
            "
          >
          </ion-input>
        </ion-col>
      </ion-row>

      <ion-row class="ion-padding-top ion-align-items-start">
        <ion-col size="6" class="ion-padding-end">
          <ion-label class="panel-label-text"
            >{{ 'register_password' | translate }}*</ion-label
          >
          <ion-input
            fill="outline"
            type="password"
            formControlName="password"
            class="ion-margin-top"
            [class.is-invalid]="
              formHelper.isFieldValidCss('password', isFormSubmitAttempted())
            "
          >
            <ion-input-password-toggle slot="end"></ion-input-password-toggle>
          </ion-input>
        </ion-col>
        <ion-col size="6" class="ion-padding-start">
          <ion-label class="panel-label-text"
            >{{ 'register_repeatPassword' | translate }}*</ion-label
          >
          <ion-input
            fill="outline"
            type="password"
            formControlName="confirmpassword"
            class="ion-margin-top"
            [class.is-invalid]="
              formHelper.isFieldValidCss(
                'confirmpassword',
                isFormSubmitAttempted()
              )
            "
          >
            <ion-input-password-toggle slot="end"></ion-input-password-toggle>
          </ion-input>
        </ion-col>
      </ion-row>

      <ion-row class="ion-margin-top ion-align-items-center">
        <ion-col size="6">
          <ion-button fill="clear" (click)="goBack()">
            <ion-icon
              name="arrow-back-outline"
              slot="icon-only"
              class="icon-x1"
            ></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col size="6">
          <ion-button
            type="submit"
            class="ion-float-right"
            color="primary"
            [disabled]="contactDetailsForm.invalid"
          >
            <small>{{ 'register_next' | translate }}</small>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-card>
